import React, { memo } from 'react';
import { useAppState } from '../RetailerFitGuide_StateContext.jsx';

const RetailerFitGuide_TechSpecs = memo(({ solution, showClampImage }) => {
  if (!solution) return null;
  const { translations } = useAppState();

  const cmValues = solution.productLengthCm ?? [];
  const inValues = solution.productLengthIn ?? [];
  const hasCm = cmValues.length > 0;
  const hasIn = inValues.length > 0;

  let barLengthValue = null;
  if (hasCm && hasIn) {
    barLengthValue = `${cmValues.join(' / ')} (${inValues.join(' / ')})`;
  } else if (hasCm) {
    barLengthValue = cmValues.join(' / ');
  } else if (hasIn) {
    barLengthValue = inValues.join(' / ');
  }

  const specificationFields = [
    ...(solution.dynamicmaxweightlb > 0
      ? [
          {
            id: 'dynamicmaxweightlb',
            displayName: translations.weightLimit,
            value: solution.dynamicmaxweightlb + ' lbs',
          },
        ]
      : []),
    {
      id: 'dataProductColorSpecification',
      displayName: translations.color,
      value: solution.dataProductColorSpecification,
    },
    {
      id: 'warranty',
      displayName: translations.warranty,
      value: 'Lifetime warranty',
    },
    ...(solution.solutionMaxBarSpreadIn > 0
      ? [
          {
            id: 'solutionMaxBarSpreadIn',
            displayName: `${translations.maxBarSpread}${showClampImage ? ' (M1)' : ''}`,
            value: solution.solutionMaxBarSpreadIn + ' in',
          },
        ]
      : []),
    ...(barLengthValue
      ? [
          {
            id: 'barLength',
            displayName: translations.barLength,
            value: barLengthValue,
          },
        ]
      : []),
  ];

  return (
    <div className="retailerFitGuide_techSpecs">
      <h2 className="heading4 mb-7 text-color--pitchBlack">{translations?.technicalSpecifications}</h2>
      <dl>
        {specificationFields.map((field, index) => (
          <React.Fragment key={index}>
            <dt className="heading6 text-color--gray90">{field.displayName}</dt>
            <dd className="paragraph--s text-color--gray80">{field.value}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
});

export default RetailerFitGuide_TechSpecs;
